import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function MapleOSForDevelopers() {
  const page = getSemanticPageByPath('/mapleos-for-developers');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
